import React, {CSSProperties, useEffect, useRef} from 'react'

import { Node, useEditor, useNode } from '@craftjs/core'
import { ImageProps } from '../../types/props'
import { getBorder, getStyle } from '../../services/HelperService'
import { useMediaQuery } from '@mui/material'
import { SupportedLanguage, useLanguage, useRecipient } from '../../contexts/RecipientContext'

import './WebsiteImage.scss'

export const WebsiteImage = (imageProps: ImageProps) => {
  const { parent, actions: {setProp} } = useNode((node) => ({parent: node.data.parent}))
  const { query: {node}} = useEditor()
  const mobile = useMediaQuery('(max-width:500px)')
	const { variables }: any = useRecipient()
  const { language, defaultLanguage }: { language: SupportedLanguage; defaultLanguage: SupportedLanguage } = useLanguage()
  const imgRef = useRef<HTMLDivElement>();

  let parentNode: Node = node(parent).get()
  let attributes: any = {}

  useEffect(() => {
		if (imageProps.variable && variables?.[imageProps.variable.var]) {
			// Get value of the used variable here 
			setProp((props: ImageProps) => props.url = variables[imageProps.variable.var])
		}
	}, [variables])

  let style: CSSProperties = {
    ...getStyle(imageProps.style, imageProps.mobileStyle, parentNode, mobile), 
    ...getBorder(imageProps.border),
    overflow: 'hidden',
    transform: `scaleX(${imageProps.scaleX}) scaleY(${imageProps.scaleY})`,
    cursor: attributes.href ? 'pointer' : 'initial'
  }

  if (imageProps.fit === "full") {
    const multiplier = mobile ? 8 : 15;
    let grid_height = imageProps.grid_height ?? 0;
    // Directly mutate local style (this is okay for internal rendering, not for persistent props)
    if (style?.gridRowEnd) {
      const rowSpanMatch = String(style.gridRowEnd).match(/span\s+(\d+)/);
      grid_height = rowSpanMatch ? parseInt(rowSpanMatch[1], 10) : 1;
    }
    style.top = `${imageProps.grid_top * multiplier}px`;
    style.height = `${grid_height * multiplier}px`;
    style.position = "absolute";
    style.left = 0;
    style.right = 0;
    style.zIndex = 0;
  }

  useEffect(() => {
    if (imageProps.fit === "full" && imgRef.current && style?.gridRowEnd) { // no need to mutate using craft.js
      const multiplier = mobile ? 8 : 15;
      const rowSpanMatch = String(style.gridRowEnd).match(/span\s+(\d+)/);
      const grid_height = rowSpanMatch ? parseInt(rowSpanMatch[1], 10) : 1;
      const imageWrapperGrid = imgRef.current.parentElement.parentElement; // parent grid
      imageWrapperGrid.style.minHeight = `${grid_height * multiplier}px`;
    }
  }, []);

  const getImage = () => {
    return <img className={`dm-edit-web-image ${imageProps.fit === 'contain' ? 'dm-edit-web-image--contain':''}`}
      style={{
        width: imageProps.imageWidth,
        height: imageProps.imageHeight}}
      draggable="false"
      // src={language === defaultLanguage || !imageProps[language]?.url ? (imageProps.url || imageProps.variable?.preview) : imageProps[language].url}/>
      // get the langauge specific image else default image
      src={imageProps[language]?.url ?? (imageProps.url || imageProps.variable?.preview)}/>
    }    

  return <div style={style} ref={imgRef}
    {...attributes}>
    { imageProps.link_enabled && imageProps.link ?
      <a href={imageProps.link} target="_blank">
        { getImage() }
      </a> :
      getImage()
    }
  </div>
}

WebsiteImage.craft = {
  displayName: 'Image'
}
